module.exports = __webpack_public_path__ + "img/장지연-Jane(Blue).e06f2b15.png";